import { GQL_ID, Order } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { IMAGE_SIZES } from '@shared/contants'


type Query = {
  userOrder: Order
}

type Variables = {
  order_id: GQL_ID
  style: string
  marketingLabelsStyle?: string
}

export const GQL_QUERY_USER_ORDER = gql`
  query userOrder ($order_id: ID!, $style: String, $marketingLabelsStyle: String) {
    userOrder(order_id: $order_id) {
      id
      shop_id
      status
      slot_id

      businessProfile {
        id
      created_at
      updated_at
      xid
      name
      type
      status
      tin
      address
      phone_number
      director
      signAuthorizedPerson
      deferredInfo {
        deferred_payment_status
        deferred_payment_days
        deferred_payment_amount_limit
        deferred_payment_available_limit
      }
      require_invoice
      bankDetails {
        accountNumber
        bankName
        bik
      }
      vat_enabled
      }

      shop {
        id
        name
        slug
        brand_id
        expressDeliveryMaxShippingTime
      }

      created_at
      placed_at
      
      total
      saledCost
      customerFinalCost
      deliveryCost
      deliveryType
      weight
      address
      comment
      slot_id

      payment_status
      payment_type
      payment_id
      paymentMethod {
        id
        type
        card
        last
        country
        pluginId
        isDefault
      }
      assembled_total
      totalCashback
      totalDiscount
      saleInfo {
        type
        name
        discount
      }

      payment_status
      payment_type
      payment_token_id
      receipts {
        id
        type
        status
        receiptQueryString
        receiptPreviewUrl
      }

      deliveryType
      weight
      address
      deliverySlot {
        id
        period {
          from
          to
        }
        slotDate
        slotTime

      }
      pickup_code
      deliveryClaim {
        id
        customerPickupCode
      }
      
      comment
      
      meta {
        id
        product_id
        shop_id
        name
        price
        unit_multiplier
        count
        weight
        total_weight
        total
        status
        assembled_count
        assembled_weight
        assembled_total
        vat_code
        product {
          id
          xid
          name
          slug
          preview(style: $style) {
            url
          }
          price_type
          count_multiplier
          brand {
            id
            name
          }
          categories {
            id
            name
          }
          marketingLabels {
            id
            title
            description
            image (style: $marketingLabelsStyle) {
              url
            }
            activeFrom
            activeUntil
            optionColor
            optionBackgroundColor
            optionLink
            optionLinkLabel
          }
        }
      }
      shop {
        id
        name
        slug
        brand_id
      }
      deliverySlot {
        id
        period {
          from
          to
        }
      }
      
      feedbacks {
        id
      }
      reviewInvite
      placedAt
      assemblingFinishedAt
      deliveryFinishedAt
      paymentReceivedAt
      pickup_code
      deliveryClaim {
        id
        customerPickupCode
        packagePickupCode
      }
    }
  }
`

export const useFetchUserOrder = (order_id: GQL_ID) => {
  const { data, loading, error, refetch } = useQuery<Query, Variables>(GQL_QUERY_USER_ORDER, {
    variables: {
      order_id,
      style: IMAGE_SIZES.LARGE,
      marketingLabelsStyle: IMAGE_SIZES.LARGE
    }
  })

  const order = data?.userOrder

  return {
    data,
    order,
    loading,
    error,
    refetch
  }
}
